/* Branded loading state — matches the static splash in public/index.html so
   there is no black flash while i18n or a lazy route chunk resolves. */
export const Splash = () => (
  <div
    aria-hidden="true"
    style={{
      position: "fixed",
      inset: 0,
      zIndex: 2147483000,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: 22,
      background: "#08080A",
      fontFamily:
        "Manrope,-apple-system,BlinkMacSystemFont,system-ui,sans-serif",
    }}
  >
    <div style={{ color: "#EDEDED", fontSize: 15, fontWeight: 600, letterSpacing: "-0.01em" }}>
      Anubhav Sahni
    </div>
    <div
      style={{
        width: 120,
        height: 2,
        background: "rgba(255,255,255,0.08)",
        borderRadius: 2,
        overflow: "hidden",
      }}
    >
      <i
        style={{
          display: "block",
          height: "100%",
          width: "40%",
          background: "#D9A441",
          borderRadius: 2,
          animation: "asSlide 1.1s ease-in-out infinite",
        }}
      />
    </div>
  </div>
);

export default Splash;
